<template>
    <div id="footer">
        <v-row no-gutters justify="center">
            <v-col cols="12" :md="7" class="pa-4 text-center background--text">
              F.C.V. Broker S.r.l. - C.so di Porta Nuova 16 - 20121 Milano
              <br/>
              P.I. 09611031007 - RUI: B000203289
              <br/>
              <a href="mailto:fcvbrokersrl@registerpec.it">fcvbrokersrl@registerpec.it</a>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name:'app-footer',
        data() {
            return {
                dialog: false
            }
        }
    }
</script>

<style lang="scss">
    #footer{
        width: 100%;
        font-size: 1rem;
        border-top: 8px solid var(--v-primary-base);
        background: var(--v-secondary-base);
        a{
            color: var(--v-primary-base);
            text-decoration: none;
            font-size: 0.9rem;
        }
        .divider{
            height: 1px;
            padding: 0;
            background: var(--v-background-base);
        }
    }
</style>
